<div
  [class.main]="!modalMode"
  class="table-fms flex max-h-[77vh] overflow-x-auto">
  <table>
    <thead>
    <tr>
      <th class="fix-w-2"></th>
      <th data-qa="email"
          class="fix-w-10p25"
          appSort
          [arr]="[employees]"
          [keySelector]="employeeSort.byEmail">
        Email
      </th>
      <th data-qa="permissions"
          class="fix-w-8p5"
          appSort
          [arr]="[employees]"
          [keySelector]="employeeSort.byPermissions">
        Permissions
      </th>
      <th
        data-qa="can-manage-users"
        class="fix-w-7p5"
        appSort
        [arr]="[employees]"
        [keySelector]="employeeSort.byCanManageUsers">
        Can Manage Users
      </th>
      <th></th>
    </tr>
    </thead>
    <tbody>
      @for (employee of employees; track employee.uuid; let i = $index) {
        <tr>
          <td [class]="{'no-hover': !isAbleToManageUsers}">
            @if (isAbleToManageUsers && employee.mail !== currentUserEmail && !employee.isOrganizationAdmin) {
              <app-three-dots-menu
                [matMenuTriggerFor]="menu"
                (click)="chosenUserEmitter(employee)">
              </app-three-dots-menu>
              <mat-menu #menu="matMenu">
                <ul class="list">
                  <app-drop-down-item
                    data-qa="member-resend-invite"
                    class="w-full"
                    [text]="'Resend invite'"
                    [iconNameAndStyling]="'letter.svg'"
                    (click)="onResendInvite(selectedEmployee)"/>
                  <app-drop-down-item
                    data-qa="member-delete"
                    class="w-full"
                    [text]="'Delete'"
                    [iconNameAndStyling]="'delete.svg; red-10'"
                    [menuItemClass]="'red'"
                    (click)="onDelete(selectedEmployee)"/>
                </ul>
              </mat-menu>
            }
          </td>
          <td [attr.data-qa]="'mail' + i"
              class="clickable">
            <span class="link-color" (click)="sendEmail(employee.mail)">
            {{ employee.mail }}
            </span>
          </td>
          <td [attr.data-qa]="'permissions' + i">
            <span>{{ employee | employeeRoleDisplay }}</span>
          </td>
          <td [attr.data-qa]="'can-manage-users' + i">
            <app-switcher
              class="small-switcher"
              [checked]="employee.isAbleToManageUsers"
              [disabled]="!isAbleToManageUsers || employee.mail === currentUserEmail || employee.isOrganizationAdmin"
              (checkedChanged)="onIsAbleToManageUsersChange(employee, $event)"
            />
          </td>
          <td></td>
        </tr>
      }
    </tbody>
  </table>
</div>
